// Reducer for the shortcutById, the sub-state under shortcuts.

import * as ActionTypes from '../constants/action_types'
import { DefaultState } from './DefaultState'
import * as ReducerUtils from './utils'

export const DefaultComparisonsListState = {
  ...DefaultState
}

export const comparisonsList = ReducerUtils.makeSingleObjectReducer({
  defaultState: DefaultComparisonsListState,
  actionRequest: ActionTypes.REQUEST_COMPARISONS,
  actionFailure: ActionTypes.REQUEST_COMPARISONS_FAILURE,
  actionReceive: ActionTypes.RECEIVE_COMPARISONS,
  actionInvalidate: ActionTypes.INVALIDATE_COMPARISONS
})
